import { NEUTRAL_ENUM_COLOR, ResolvedOptionColor } from '~/common/styles/enum-colors'
import { DossIcon } from '~/components/DossIcon'

interface EnumOptionMarkProps {
  color?: ResolvedOptionColor | null
  iconName?: string | null
  /** Render an empty fixed-size slot when there's no mark, so rows stay aligned when the set uses icons */
  reserveSpace?: boolean
}

const ICON_SIZE = 14

/**
 * The leading mark for a single-select enum value (dropdown row, trigger, or grid cell). An icon (when
 * present) wins and renders in the vivid accent tone; otherwise a color renders a filled dot. With neither,
 * an optional reserved slot keeps rows aligned in a set that mixes icon and icon-less options. Every mark
 * sits flush, so the gap to the label is the same for a dot as for an icon.
 */
export const EnumOptionMark = ({ color, iconName, reserveSpace }: EnumOptionMarkProps) => {
  if (iconName) {
    const palette = color ?? NEUTRAL_ENUM_COLOR
    return <DossIcon color={palette.vivid} name={iconName} size={ICON_SIZE} />
  }

  if (color) {
    return (
      <span className="size-2 shrink-0 rounded-full" style={{ backgroundColor: color.vivid }} />
    )
  }

  // Matches the icon's footprint, since the slot is only reserved when the set has icons
  if (reserveSpace) {
    return <span className="size-3.5 shrink-0" />
  }

  return null
}
